<template>
  <div class="p-5">
    <h1 class="text-center text-3xl font-[youyuan] tracking-[20px] my-4 mb-12 font-semibold">{{ title }}</h1>
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  title: string;
}

defineProps<Props>();
</script>
